import React from "react";
import { Stack, Typography } from "@mui/material";
import SubContainer from "./SubContainer";
import { roundIfDecimal } from "../../../Utils/Utils";

const PerformanceList = ({ title, items, icon, iconColor }) => {
  return (
    <SubContainer spacing={2}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography fontSize={20} sx={{ color: iconColor }}>
          {icon}
        </Typography>
        <Typography variant="h5" fontWeight={700} color={"white"}>
          {title}
        </Typography>
      </Stack>

      {items.map((item, idx) => (
        <Stack
          direction="row"
          justifyContent="space-between"
          key={item.hotelName + idx}
          spacing={1}
        >
          <Typography
            color={"#b6bed3"}
            sx={{
              flex: 1,
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {item.hotelName}
          </Typography>
          <Typography fontWeight={600} color={"white"}>
            {item.occupancy + "%"}
          </Typography>
        </Stack>
      ))}
    </SubContainer>
  );
};
export default PerformanceList;
